import classNames from 'classnames';

import styles from './_index.module.scss';

interface ToolbarProps {
  children?: React.ReactNode;
  className?: string;
  tools: React.ReactNode[];
}

const Toolbar = ({ children, className, tools }: ToolbarProps) => {
  return (
    <div className={classNames(styles['toolbar'], className)}>
      <div>{children}</div>
      {tools.length > 0 && (
        <ul className={styles['toolbar-tools']}>
          {tools.map((tool, index) => (
            <li key={index}>{tool}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Toolbar;
